import { combineReducers } from "redux";
import assistantSlice from './assistantSlice/index';
import themeSlice from './themeSlice/index';
import customizationSlice from "./customizationSlice";
import authenticationSlice from "./authenticationSlice";

const rootReducer = combineReducers({
    authentication: authenticationSlice,
    assistant: assistantSlice,
    theme: themeSlice,
    customization: customizationSlice
});

export default rootReducer;